module.exports = __webpack_public_path__ + "img/about-page5-img-2.906236e7.jpg";